import { useNavigate } from "react-router-dom";
import ServicoFormCadastro from "../../../Components/Populados/Financeiro/Faturamento/Servico/ServicoFormCadastro";

export default function Cadastro() {
    const navigate = useNavigate();
    return <ServicoFormCadastro 
        onCancelar={(ev) => navigate(-1)}
        onSalvarSucesso={(ev) => navigate(-1)}
    />
}